import { createContext } from "react";

const CodigoContext = createContext();

export default CodigoContext;
